import { render } from "./Main.vue?vue&type=template&id=0a82f6c0"
import script from "./Main.vue?vue&type=script&lang=ts"
export * from "./Main.vue?vue&type=script&lang=ts"
script.render = render

export default script